import { DateRangeOutlined } from '@mui/icons-material';
import { Button, Grid, Typography } from '@mui/material';

interface IValidationCard {
  textCard: string;
  selected: boolean;
  setSelectedTimePrice: () => void;
}

const ValidationCard = ({
  textCard,
  selected,
  setSelectedTimePrice,
}: IValidationCard) => {
  return (
    <Grid item xs={6} sm={4} md={2}>
      <Button
        onClick={setSelectedTimePrice}
        name="expires_at"
        variant={selected ? 'contained' : 'outlined'}
        sx={theme => ({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          gap: 2,
          width: '100%',
          height: '90px',
          borderRadius: '12px',
          border: 'solid 1px #BFBFBF',
          p: 2,
          color: `${
            selected ? [theme.palette.primary.contrastText] : 'text.secondary'
          }`,
        })}
      >
        <DateRangeOutlined />
        <Typography variant="body2" textAlign="start">
          {textCard}
        </Typography>
      </Button>
    </Grid>
  );
};

export default ValidationCard;
